import React from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

export default function SuperadminSettings() {
    return (
        <>
        <Header />
        <div className="min-h-screen bg-gray-50">
            <div className="grid grid-cols-12">
                <aside className="col-span-2 hidden lg:flex">
                    <Sidebar />
                </aside>

                <main className="col-span-12 lg:col-span-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="flex items-start justify-between mb-8">
                        <div>
                            <h1 className="text-3xl font-extrabold text-gray-900">Settings</h1>
                            <p className="mt-2 text-sm text-gray-500">Manage global configuration for the platform.</p>
                        </div>
                        <div className="flex items-center gap-3">
                            <button className="px-4 py-2 bg-white border rounded-md shadow-sm">Reset</button>
                            <button className="px-4 py-2 bg-indigo-600 text-white rounded-md">Save</button>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="bg-white p-6 rounded-lg shadow">
                            <h3 className="text-lg font-medium mb-4">General</h3>
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Site Name</label>
                                    <input className="w-full mt-1 px-3 py-2 border rounded-md" defaultValue="Stokraze" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">Contact Email</label>
                                    <input className="w-full mt-1 px-3 py-2 border rounded-md" defaultValue="support@stokraze.ng" />
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow">
                            <h3 className="text-lg font-medium mb-4">Security</h3>
                            <div className="space-y-4">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <div className="text-sm font-medium">Require strong passwords</div>
                                        <div className="text-xs text-gray-500">Enforce password complexity for all users</div>
                                    </div>
                                    <input type="checkbox" className="h-5 w-5" defaultChecked />
                                </div>

                                <div className="flex items-center justify-between">
                                    <div>
                                        <div className="text-sm font-medium">Enable 2FA</div>
                                        <div className="text-xs text-gray-500">Require two-factor authentication for admins</div>
                                    </div>
                                    <input type="checkbox" className="h-5 w-5" />
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
        </>
    );
}
